var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-8 cda-doc"},[_c('iframe',{ref:"frame",staticClass:"iframe",attrs:{"id":'cda-'+_vm.id},on:{"load":function($event){$event.stopPropagation();return _vm.onCdaLoad.apply(null, arguments)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }